module.exports = __webpack_public_path__ + "static/media/img7.28a39866.jpg";